import {FC} from 'react'
import s from './user-subscriptions.module.css'
import {SubscriptionListProps} from ".";
import UserSubscriptionsRow from "./user-subscriptions-row";

const UserSubscriptions: FC<SubscriptionListProps> = ({data}) => {
  return (<div className={s.root}>
      {data.length > 0 && data.map((item: any, index: any) => {
        return (<UserSubscriptionsRow item={item} key={index}/>)
      })}
      {data.length == 0 && <div>Você não possui assinaturas ativas</div>}
    </div>)
}

export default UserSubscriptions
